/*
 * @Author: aalizzwell 
 * @Date: 2019-05-30 18:57:34 
 * @Last Modified by:   aalizzwell 
 * @Last Modified time: 2019-05-30 18:57:34 
 */
import { PathTreeNodeBuilder } from './path_tree_node_builder';
import { ParentTreeNodeBuilder } from './parent_tree_node_builder';
import { Type } from '@angular/core';

export class TreeNodeBuilderFactory {
    static getBuilder(hierarchyInfo: { [propName: string]: any }): Type<PathTreeNodeBuilder | ParentTreeNodeBuilder> {
        let builder: Type<PathTreeNodeBuilder | ParentTreeNodeBuilder> = PathTreeNodeBuilder;
        if (hierarchyInfo.hasOwnProperty("path")) {
            builder = PathTreeNodeBuilder;
        } else if (hierarchyInfo.hasOwnProperty("parentElement")) {
            builder = ParentTreeNodeBuilder;
        }

        return builder;
    }
}